import { Link } from "react-router-dom";
function Hero(){

return(

<section className="hero">


<div className="hero-text">

<h1>
CUTIES
</h1>


<p>
Baby & Kids Boutique
</p>


<div className="hero-buttons">

<Link to="/shop" className="shop-link">
  <button>
    Shop now
  </button>
</Link>


<a 
  href="https://www.instagram.com/cuties_leb?igsh=bmVtOWozZzNkMGRv&utm_source=qr"
  target="_blank"
  rel="noreferrer"
>
  <button>
    Follow Us
  </button>
</a>

</div>


</div>



<img

src="https://i.postimg.cc/sXjTLGGS/Whats-App-Image-2026-07-11-at-1-47-41-PM-removebg-preview.png"

className="Logo"

/>


</section>

)

}


export default Hero;